import tmhRequest from '@/config/tmhRequest'

export default {
    searchCouponOrderReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/couponorderreport/searchcouponorderreportcount',
            method: 'post',
            data: data,
        })
    },
    searchCouponOrderReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/couponorderreport/searchcouponorderreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportCouponOrderReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/couponorderreport/exportcouponorderreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/couponorderreport.js